export const GET_EXPORT_CONTENT = 'GET_EXPORT_CONTENT';
export const CHANGE_EXPORT_FILE = 'CHANGE_EXPORT_FILE';
export const START_OVER = 'START_OVER';
export const GET_EXPORT_PAGES_CONTENT = 'GET_EXPORT_PAGES_CONTENT';
export const PARSE_XML_NODES = 'PARSE_XML_NODES';
export const UPDATE_SELECTED_PAGES = 'UPDATE_SELECTED_PAGES';
export const SHOW_DRAFT_PAGES = 'SHOW_DRAFT_PAGES';
export const SHOW_PUBLISHED_PAGES = 'SHOW_PUBLISHED_PAGES';